<template>
  <b-container>
    <b-card-group v-if="respuestaReceta">
      <div v-if="respuestaReceta.receta && respuestaReceta.receta.length > 0 && medicamentosRecetados && medicamentosRecetados.length > 0">
        <b-card title="Detalles de la Tarjeta">
          <b-card-text>
            <p>
              <strong>Paciente:</strong>
              {{
                this.itemReceta.consultamedica.cita.paciente.persona
                  .primerNombre
              }}
              {{
                itemReceta.consultamedica.cita.paciente.persona.primerApellido
              }}
            </p>
            <p>
              <strong>Doctor:</strong>
              {{
                itemReceta.consultamedica.cita.doctor.idPersona.primerNombre
              }}
              {{
                itemReceta.consultamedica.cita.doctor.idPersona.primerApellido
              }}
            </p>
            <p>
              <strong>Especialidad:</strong>
              {{
                itemReceta.consultamedica.cita.doctor.especialidad.descripcion
              }}
            </p>
            <p>
              <strong>Establecimiento:</strong>
              {{ itemReceta.consultamedica.cita.establecimiento.Descripcion }}
            </p>
            <p><strong>Fecha:</strong> {{ formatFecha(itemReceta.fecha) }}</p>
          </b-card-text>
         
          <b-table :items="medicamentosRecetados" :fields="fieldsMedicamentos">
            <template #cell(despachado)="data">
              <b-form-checkbox
                v-model="data.item.despachado"
                @change="() => handleCheckboxChange(data.item)"
                :disabled ="data.item.bloqueado"
              >
              </b-form-checkbox>
            </template>
            <template #cell(name)="data">
              {{ data.item.nombreMedicamento }}
            </template>
            <template #cell(estado)="data">
              <label 
                  v-if="data.item.despachado" 
                  style="background-color: #dc3545; color: white; border-radius: 8px; padding: 10px;">
                  Despachado 
            </label>

              <label 
                v-else
                style="background-color: #198754; color: white; border-radius: 8px; padding: 10px;">
                Por retirar 
          </label>

            </template>
          </b-table>
          <b-row>
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              <b-row>
              <b-col class="mx-1">
              <b-button
                variant="primary"
                @click="downloadRecetaTicket(idRecetaT)"
              >
                Ticket
              </b-button>
              </b-col>
              <b-col class="mx-1">
              <b-button  variant="primary" @click="downloadReceta(idRecetaT)">
                Receta
              </b-button>
              
             
              </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <b-row class="justify-content-center align-items-center">
            <b-col cols="12" md="4" class="text-center">
              <b-button variant="warning" @click="guardarCambios" size="lg">
                <i class="fas  fa-box"></i> Guardar 
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div v-else>
        <b-card cols="10" class="mt-2">
          <h1>  <i style="color: #dc3545;" class="fas fa-capsules"></i> Medicamentos eliminados por el médico. <i style="color: #dc3545;" class="fas fa-circle-xmark"></i></h1>
        </b-card>
      </div>
    </b-card-group>
    <div v-else>
      <p>Cargando receta o error en la consulta...</p>
    </div>
  </b-container>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardGroup,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BFormCheckbox,
  BFormGroup,
  BMedia,
  BAvatar,
  BLink,
  BCardText,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BContainer,
} from "bootstrap-vue";
import actions from "@/assets/utils/utils";
import BCardCode from "@core/components/b-card-code";
import vSelect from "vue-select";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { comprobarPermisos } from "@/shared/helpers";
import Vue from "vue";

export default {
  components: {
    BCard,
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BCardGroup,
    BMedia,
    BAvatar,
    BCardText,
    BOverlay,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormCheckbox,
    vSelect,
    BContainer,
  },

  name: "MyPanel",

  data() {
    return {
      
      respuestaReceta: null, // Aquí se almacena la respuesta de la consulta GraphQL
      despachado: false,
      idRecetaT: null,
      fieldsMedicamentos: [
        { key: "despachado", label: "Despachar", sortable: false }, // Columna para el checkbox
        { key: "medicamento", label: "Medicamento" },
        { key: "estado", label: "Estado" },
        { key: "cantidad", label: "Cantidad" },
      ],
    };
  },
  created() {
    // aqui se colocan las funciones que aparezcan cargadas cuando se haga un post o un f5 de la misma.
    const idReceta = this.$route.params.id;
    this.idRecetaT = idReceta;
    console.log(this.idRecetaT);
    comprobarPermisos(this.$route);
    this.fetchReceta(idReceta);
  },

  mounted() {},
  computed: {
    medicamentosRecetados() {
  if (this.itemReceta && this.itemReceta.medicamentosRecetados) {
    return this.itemReceta.medicamentosRecetados
      .filter((med) => med.estado === '1') // Filtrar solo los que tienen estado '1'
      .map((med) => {
        return {
          medicamento: med.medicamento.nombre,
          cantidad: med.cantidad,
          dosis: med.dosis,
          despachado: med.estadoTransitorio === "Despachado" ? true : false,
          bloqueado: med.despachado,
          id: med.id,
        };
      });
  }
  return [];
},
  },

  methods: {
    formatFecha(fecha) {
      return new Date(fecha).toISOString().split("T")[0]; // Esto devolverá solo la parte de la fecha
    },
    handleCheckboxChange(medicamento) {
      const medicamentoOriginal =
        this.respuestaReceta.receta[0].medicamentosRecetados.find(
          (m) => m.id === medicamento.id
        );
      console.log(medicamentoOriginal);
      if (medicamentoOriginal) {
        medicamentoOriginal.despachado = medicamento.despachado;
        console.log(
          `Medicamento ID: ${medicamento.id}, Despachado: ${medicamento.despachado}`
        );
      }
    },
    // async downloadReceta(idReceta) {
    //     console.log("id", idReceta);
    //     const selectedMedicamentIds = this.getSelectedMedicamentIds();
    //     const query = `
    //         query qrGetDocumentReceta($idReceta: String!, $selectedMedicamentIds: [String!]) {
    //             getDocumentReceta(idReceta: $idReceta, medicamentosSeleccionados: $selectedMedicamentIds) {
    //                 status
    //                 message
    //                 recetaPdf
    //                 receta{
    //                     id
    //                 }
    //             }
    //         }
    //     `;
    //     try {
    //         const response = await axios.post(rutas.axios + 'api', {
    //             query,
    //             variables: {
    //                 idReceta: idReceta,
    //                 selectedMedicamentIds: selectedMedicamentIds
    //             }
    //         });

    //         // Resto de la lógica de manejo de la respuesta
    //         if (response.status === 200 && response.data.data.getDocumentReceta) {
    //             const item = response.data.data.getDocumentReceta.recetaPdf;
    //             console.log("receta", item);
    //             actions.cargarArchivos(item, "receta_" + idReceta + ".pdf", "data:application/pdf;base64");
    //         } else {
    //             console.error("No se recibieron datos para la receta");
    //         }
    //     } catch (error) {
    //         console.error("Error al cargar la receta:", error);
    //     }
    // },

    async downloadReceta(idReceta) {
      const selectedMedicamentIds = this.getSelectedMedicamentIds();
      const query = `                
                query qrGetDocumentReceta($idReceta: String!, $idsMedicamentosSeleccionados: [String!]) {
                    getDocumentReceta(idReceta: $idReceta, idsMedicamentosSeleccionados: $idsMedicamentosSeleccionados) {
                        status
                        message
                        recetaPdf
                        receta{
                            id
                        }
                    }
                }
            `;
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: {
            idReceta: idReceta,
            idsMedicamentosSeleccionados: selectedMedicamentIds,
          },
        });
        if (response.status === 200 && response.data.data.getDocumentReceta) {
          const item = response.data.data.getDocumentReceta.recetaPdf;
          console.log("receta", item);
          actions.cargarArchivos(
            item,
            "receta_" + idReceta + ".pdf",
            "data:application/pdf;base64"
          );
        } else {
          console.error("No se recibieron datos para la receta");
        }
        // Manejo de la respuesta...
      } catch (error) {
        console.error("Error al cargar la receta:", error);
      }
    },
    async downloadRecetaTicket(idReceta) {
      const selectedMedicamentIds = this.getSelectedMedicamentIds();
      const query = `                
                query qrGetDocumentRecetaTicket($idReceta: String!, $idsMedicamentosSeleccionados: [String!]) {
                    getDocumentRecetaTicket(idReceta: $idReceta, idsMedicamentosSeleccionados: $idsMedicamentosSeleccionados) {
                        status
                        message
                        recetaPdf
                        receta{
                            id
                        }
                    }
                }
            `;
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: {
            idReceta: idReceta,
            idsMedicamentosSeleccionados: selectedMedicamentIds,
          },
        });
        if (
          response.status === 200 &&
          response.data.data.getDocumentRecetaTicket
        ) {
          const item = response.data.data.getDocumentRecetaTicket.recetaPdf;
          console.log("receta", item);
          actions.cargarArchivos(
            item,
            "recetaticket_" + idReceta + ".pdf",
            "data:application/pdf;base64"
          );
        } else {
          console.error("No se recibieron datos para la receta");
        }
        // Manejo de la respuesta...
      } catch (error) {
        console.error("Error al cargar la receta:", error);
      }
    },
    async guardarCambios() {
      // Preparar los datos de los medicamentos recetados para la mutación
      console.log(
        "Estado de medicamentos antes de actualizar:",
        this.respuestaReceta.receta[0].medicamentosRecetados
      );
      const medicamentosParaActualizar =
        this.respuestaReceta.receta[0].medicamentosRecetados
          .filter((medicamento) => medicamento.despachado)
          .map((medicamento) => ({
            id: parseInt(medicamento.id),
            datos: {
              estadoTransitorio: "Despachado",
            },
          }));

      console.log("Medicamentos para actualizar:", medicamentosParaActualizar);

      const idReceta = this.$route.params.id;
      // Definir la consulta de la mutación GraphQL
      const mutation = `
                mutation actualizarEstadoMedicamentoRecetado($idReceta: String!, $medicamentos: [MedicamentoRecetadoUpdateInput]!) {
                    actualizarEstadoMedicamentoRecetado(idReceta: $idReceta, medicamentos: $medicamentos) {
                        status
                        message
                    }
                }
            `;

      // Preparar las variables para la mutación
      const variables = {
        idReceta: idReceta, // Asume que tienes el ID de la receta disponible
        medicamentos: medicamentosParaActualizar,
      };
      console.log("Datos a enviar en la mutación:", {
        idReceta,
        medicamentosParaActualizar,
      });

      try {
        // Realizar la solicitud al servidor
        const response = await axios.post(rutas.axios + "api", {
          query: mutation,
          variables: variables,
        });
        console.log("Respuesta de la mutación:", response.data);
        // Manejar la respuesta
        if (
          response.data.data.actualizarEstadoMedicamentoRecetado.status ===
          "Success"
        ) {
          console.log(
            response.data.data.actualizarEstadoMedicamentoRecetado.message
          );
          this.$router.push({ name: "consultar_receta_creada" });
        } else {
          console.error(
            response.data.data.actualizarEstadoMedicamentoRecetado.message
          );
        }
      } catch (error) {
        console.error("Error al guardar cambios en los medicamentos", error);
      }
    },
    getSelectedMedicamentIds() {
      console.log("medicamentosRecetados:", this.medicamentosRecetados);
      return this.medicamentosRecetados
        .filter((med) => med.despachado)
        .map((med) => med.id);
    },

    async fetchReceta(idReceta) {
      console.log("ID de la receta a buscar:", idReceta);

      const query = `
                query GetRecetaById($idReceta: String!) {
                    getRecetaById(idReceta: $idReceta) {
                        receta {
                            estadoTransitorio
                            id
                            consultamedica{
                                cita {
                                    paciente {
                                        id
                                        persona {
                                            primerNombre
                                            identificacion
                                            primerApellido
                                        }
                                    }
                                    doctor {
                                        id
                                        idPersona {
                                            primerNombre
                                            identificacion
                                            primerApellido
                                        }
                                        especialidad {
                                            descripcion
                                        }
                                    }
                                    establecimiento {
                                        id
                                        Descripcion
                                    }
                                }
                            }
                            fecha
                            medicamentosRecetados {
                                id
                                dosis
                                estado
                                cantidad
                                estadoTransitorio
                                medicamento {
                                    nombre
                                }
                            }
                        }
                        message
                        status
                    }
                }
            `;

      const variables = {
        idReceta: idReceta,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });
        console.log("Respuesta del servidor:", response.data);
        if (response.data.data.getRecetaById.status === "Success") {
          this.itemReceta = response.data.data.getRecetaById.receta[0]; // Asignar la receta directamente
          this.respuestaReceta = response.data.data.getRecetaById;
          console.log(this.itemReceta);

          // Agregar la propiedad 'despachado' a cada medicamento recetado
          if (this.itemReceta && this.itemReceta.medicamentosRecetados) {
            this.itemReceta.medicamentosRecetados.forEach((medicamento) => {
              medicamento.despachado = medicamento.estadoTransitorio === "Despachado" ? true : false;
              medicamento.bloqueado = medicamento.despachado ? true : false
            });
          }
        } else {
          console.error("Error al obtener la receta:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
  },
};
</script>

<style scoped>
.panel {
  border: 1px solid #ddd;
  border-radius: 4px;
}
.panel-header,
.panel-footer {
  padding: 10px;
  background-color: #f5f5f5;
}
.panel-body {
  padding: 15px;
  background-color: #fff;
}
.card .card-title {
  margin-bottom: 1.53rem; /* Margen inferior personalizado */
  text-align: center; /* Centrar el texto del título */
  font-size: 2em; /* Cambiar el tamaño del título */
}
.card-group {
  display: contents;
  flex-flow: row wrap;
}
</style>
